import FilePickerPanel from './FilePickerPanel';

export default FilePickerPanel;